<template>
  <div>


    <div class="my-container">
      <h2>
        Download for domain annotation
      </h2>
      <el-table
          fit
          :header-cell-style="{color: 'black'}"
          :row-style="{height: '30px'}"
          :cell-style="{padding: '0', color: 'black', margin: '0'}"
          :data="annotationTable.slice((currentPage_label-1)*pageSize_label,currentPage_label*pageSize_label)"
          stripe>
        <el-table-column prop="Technique" label="Technique"  width="100px" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="PMID" label="PMID" width="100px"  sortable show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.PMID === '-'">
              {{scope.row.PMID}}
            </span>
            <span v-else>
              <a target="_blank" class="buttonText" :href="gotoDetails(scope.row.PMID)">{{scope.row.PMID}}</a>
            </span>
            <!--              <a target="_blank" class="buttonText" href="https://pubmed.ncbi.nlm.nih.gov/30154148/">link</a>-->
            <!--            <a target="_blank" class="buttonText" :href="gotoDetails(scope.row.PMID)">{{scope.row.PMID}}</a>-->
            <!--              <a v-on:click="gotoDetails(scope.row.pmid)" class="my-a"></a>-->
          </template>
        </el-table-column>
        <el-table-column prop="Title" label="Title"  show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="Name" label="Sample"  width="100px" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="Annotation_label" label="Annotation Label" width="150px"  show-overflow-tooltip>
          <template slot-scope="scope">
            <!--              <a target="_blank" class="buttonText" v-on:click="gotoDetails(DETAILS)">link</a>-->
            <a :href="scope.row.Annotation_label_path" class="my-a" target="_blank">{{ scope.row.Annotation_label }}</a>
            <!--              <a v-on:click="myDownload(scope.row.Expression_path)" class="my-a">{{ scope.row.Expression }}</a>-->
          </template>
        </el-table-column>
        <el-table-column prop="Annotation_img" label="Annotation Image" width="150px" show-overflow-tooltip>
          <template slot-scope="scope">
            <template v-if="scope.row.Annotation_img === 'F'">
              <a :href="scope.row.Annotation_img_path" class="my-a-unable" target="_blank">{{ scope.row.Annotation_img }}</a>
            </template>
            <template v-else>
              <a href="" class="my-a" target="_blank">{{ scope.row.Annotation_img }}</a>
            </template>
            <!--              <a target="_blank" class="buttonText" v-on:click="gotoDetails(DETAILS)">link</a>-->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination align='center' @size-change="handleSizeChange_label" @current-change="handleCurrentChange_label"
                     :current-page="currentPage_label"
                     :page-sizes="[1,5,10,20]"
                     :page-size="pageSize_label"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="annotationTable.length">
      </el-pagination>
    </div>

    <div class="my-container">
      <h2>
        Download for raw data and downstream analysis results
      </h2>
      <el-table
          fit
          :row-style="{height: '30px'}"
          :cell-style="{padding: '0', color: 'black', margin: '0'}"
          :data="tableData.slice((currentPage-1)*pageSize,currentPage*pageSize)"
          stripe
          :header-cell-style="{color: 'black'}">
        <el-table-column prop="Technique" label="Technique" width="100px" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="PMID" label="PMID" width="100px" sortable show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.PMID === '-'">
              {{scope.row.PMID}}
            </span>
            <span v-else>
              <a target="_blank" class="buttonText" :href="gotoDetails(scope.row.PMID)">{{scope.row.PMID}}</a>
            </span>
            <!--            <a target="_blank" class="buttonText" :href="gotoDetails(scope.row.PMID)">{{scope.row.PMID}}</a>-->
            <!--              <a target="_blank" class="buttonText" href="https://pubmed.ncbi.nlm.nih.gov/30154148/">link</a>-->
            <!--              <a v-on:click="gotoDetails(scope.row.pmid)" class="my-a"></a>-->
          </template>
        </el-table-column>
        <el-table-column prop="Title" label="Title" min-width="300px" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="Expression" label="Link" show-overflow-tooltip width="100px">
          <template slot-scope="scope">
            <!--              <a target="_blank" class="buttonText" v-on:click="gotoDetails(DETAILS)">link</a>-->
            <a :href="scope.row.Expression_path" class="my-a" target="_blank">link</a>
            <!--              <a v-on:click="myDownload(scope.row.Expression_path)" class="my-a">{{ scope.row.Expression }}</a>-->
          </template>
        </el-table-column>
        <el-table-column prop="Annotation" label="Meta information" show-overflow-tooltip width="200px">
          <template slot-scope="scope">
            <!--              <a target="_blank" class="buttonText" v-on:click="gotoDetails(DETAILS)">link</a>-->
            <a :href="scope.row.Annotation_path" class="my-a" target="_blank">{{ scope.row.Annotation }}</a>
            <!--              <a v-on:click="myDownload(scope.row.Expression_path)" class="my-a">{{ scope.row.Expression }}</a>-->
          </template>
        </el-table-column>
        <el-table-column prop="SVGenes" label="Downstream analysis results" show-overflow-tooltip width="230px">
          <template slot-scope="scope">
            <!--              <a target="_blank" class="buttonText" v-on:click="gotoDetails(DETAILS)">link</a>-->
            <a :href="scope.row.SVGenes_path" class="my-a" target="_blank">{{ scope.row.SVGenes }}</a>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination align='center' @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page="currentPage"
                     :page-sizes="[1,5,10,20]"
                     :page-size="pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="tableData.length">
      </el-pagination>
    </div>
  </div>

</template>

<script>
export default {
  name: "Download",
  data(){
    return {
      tableData: [
        {
          Technique: "ST",
          PMID: "34083791",
          Title: "Spatial transcriptomics at subspot resolution with BayesSpace",
          Annotation: "anno_27365449.tar.gz",
          Annotation_path: "/Dataset/20210101",
          Expression: "st_34083791.tar.gz",
          Expression_path: "/Dataset/20210101",
          SVGenes: "st_34083791_SVG.tar.gz",
          SVGenes_path: '/Dataset/Marker/20210101'
        },
      ],
      annotationTable: [
        {
          Technique: "ST",
          PMID: "34083791",
          Title: "Spatial transcriptomics at subspot resolution with BayesSpace",
          Name: 'sample',
          Annotation_label: "st_34083791.tar.gz",
          Annotation_label_path: "/Dataset/20210101",
          Annotation_img: "st_34083791_SVG.tar.gz",
          Annotation_img_path: '/Dataset/Marker/20210101'
        },
      ],
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      currentPage_label: 1, // 当前页码
      total_label: 20, // 总条数
      pageSize_label: 10 // 每页的数据条数
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.currentPage = 1;
      this.pageSize = val;
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange_label(val) {
      console.log(`每页 ${val} 条`);
      this.currentPage_label = 1;
      this.pageSize_label = val;
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange_label(val) {
      console.log(`当前页: ${val}`);
      this.currentPage_label = val;
    },
    gotoDetails(DETAILS) {
      if (DETAILS === ''){
        return
      }
      return 'https://pubmed.ncbi.nlm.nih.gov/'+DETAILS+'/'
    },
    getData(){
      let _this = this
      _this.$axios.get(
          'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/download')
          .then(function (response){
            console.log(response.data)
            _this.tableData = response.data.downloadData
          })

      _this.$axios.get(
          'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/download_label')
          .then(function (response){
            console.log(response.data)
            _this.annotationTable = response.data.labelData
          })
    },
  },
}
</script>

<style scoped>
.my-a{
  cursor:pointer;
  color: blue;
  text-decoration:underline;
}
.my-a-unable{
  pointer-events:none;
  cursor:pointer;
  color: grey;
  text-decoration:none;
}
</style>
